import _extends from "@babel/runtime/helpers/extends";
import { isDesignMode } from "../../common/util/util";
var CnLayoutContent = function CnLayoutContent(props) {
  var _ref = props || {},
    children = _ref.children,
    normalStyle = _ref.normalStyle;
  var extraProps = _extends({}, normalStyle);
  var isDesign = isDesignMode(props);
  if (isDesign) {}
  return children;
};
CnLayoutContent.displayName = 'CnLayoutContent';
export default CnLayoutContent;
export { CnLayoutContent };